/**
 * Created by Ning Jiang on 10/3/2018.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {TombstoneGameMode} from "../gamemode/TombstoneGameMode";
import {TombstoneNoMercy} from "../TombstoneNoMercy";

export class TombstoneSpinController extends SpinController {

    private _overlayWild:boolean[][] | undefined;

    constructor() {
        super();
        TombstoneNoMercy.spinController = this;
    }

    protected parseGameData(data:ParsedServerData):void {
        this._overlayWild = data.overlayWilds;
    }

    public clear() {
        this._overlayWild = undefined;
    }

    protected getReelsGameConfigFromPreviousGameData():boolean[] {
        const config:boolean[] = super.getReelsGameConfigFromPreviousGameData();
        if((this._mode === GameMode.RESPIN || this._mode === TombstoneGameMode.SUPER_FREESPIN) && this._overlayWild != null) {
            this._overlayWild.forEach((reelOverlay:boolean[], reelId:number) => {
                // In this game, the overlay wilds always takes the whole reel.
                if(reelOverlay[0]) {
                    config[reelId] = false;
                }
            })
        }

        return config;
    }
}